<template>
	<div>
		<div class="wrapper wrapper-content animated fadeInRight">
			<div class="row">
				<div class="col-lg-12">
					<div class="ibox float-e-margins">
						<div class="ibox-title">
							<h4 v-if="items && items.length">
								Random Cli 1 to {{ items.length }} of
								{{ items.length }}
							</h4>
						</div>
						<div class="ibox-content">
							<Loading v-if="loading" />
							<table class="table footable table-stripped footable-loaded" v-if="!loading">
								<thead>
									<tr>
										<th>Main</th>
										<th>Random</th>
										<th>Created</th>
									</tr>
								</thead>
								<tbody>
									<tr class="gradeX" v-for="(randCli, index) in items" v-bind:key="randCli.id"
										data-index="0" style="display: table-row">
										<td>
											<span class="footable-toggle"></span>
											<input type="checkbox" v-model="selectedItems[index]"
												:value="randCli.id" />&nbsp;
											{{ randCli.cidInText  }}
										</td>
										<td>
											{{ randCli.cidOutText  }}
										</td>
										<td>
											{{ randCli.last_modified ? new Date(randCli.last_modified*1000) : "" }}
										</td>
									</tr>
								</tbody>
								<tfoot>
									<td colspan="2">
										<router-link class="btn btn-sm btn-success mr-2" :to="{ path: '/create/' }">
											New</router-link>
										<button class="btn btn-sm btn-success mr-2" @click="selectAllClicked()"
											:disabled="items.length == 0">
											{{ selectAllButtonText }}
										</button>
										<button class="btn btn-sm btn-success" @click="deleteItem()"
											:disabled="selectedItems.length == 0">
											Delete Selected
										</button>
									</td>
								</tfoot>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {RandomCliApiService} from "../../services/RandomCliApiService";
import {NumbersApiService} from "../../services/NumbersApiService";
import Loading from "../../components/Loading";
export default {
	data: () => ({
		loading: false,
		items: [],
		selectedItems: [],
		validCsvHeaders: ["name", "description", "phone"],
		selectAllButtonText: "Select All"
	}),

	components: {Loading},

	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");
		this.SwalService = $injector.get("SwalService");
		this.RandomCliApiService = new RandomCliApiService(CoreApiService);
		this.NumbersApiService = new NumbersApiService(CoreApiService);
	},
	async mounted() {
		this.load();
	},

	methods: {
		selectAllClicked() {
			this.selectedItems = this.selectedItems.map(isSelected => this.selectAllButtonText === "Select All");
			this.selectAllButtonText = this.selectAllButtonText === "Select All" ? "Deselect All" : "Select All";
		},
		async load() {
			this.loading = true;
			this.items = await this.RandomCliApiService.list();
			this.selectedItems = new Array(this.items.length).fill(false);
			this.numbersData = await this.NumbersApiService.list();
			const deleteStr = " deleted number";
			this.items.forEach(item => {
				item.cidInText = this.numbersData.find(n => n.number === (item.cid_in.startsWith("972") ? "0" + item.cid_in.substring(3)	: "00" + item.cid_in))?.display;
				item.cidOutText = this.numbersData.find(n => n.number === (item.cid_out.startsWith("972") ? "0" + item.cid_out.substring(3)	: "00" + item.cid_out))?.display;
				if (!item.cidInText) {
					item.cidInText = item.cid_in.startsWith("972") ? "0" + item.cid_in.substring(3)	+ deleteStr : "00" + item.cid_in + deleteStr;
				}
				if (!item.cidOutText) {
					item.cidOutText = item.cid_out.startsWith("972") ? "0" + item.cid_out.substring(3)	+ deleteStr : "00" + item.cid_out + deleteStr;
				}
			});
			this.loading = false;
		},
		async deleteItem() {
			if (!this.selectedItems.find(isSelected => isSelected === true)) {
				this.SwalService.popup({
					title: "Error",
					type: "warning",
					text: "You must select one or more items to delete"
				});
				return;
			}

			let promises = this.selectedItems.map((isSelected, index) => {
				if (isSelected) {
					return this.RandomCliApiService.delete(this.items[index].id);
				}
			});

			try {
				await Promise.all(promises);
				this.SwalService.popup({
					title: "Deleted"
				}).then((s) => {
					this.selectedItems = [];
					this.load();
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: e.message || e.statusCode || e,
					type: "error"
				}).then((s) => {
					this.load();
				});
			}
		}
	}
};
</script>

<style scoped>

</style>